import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ImageCropperModule } from 'ngx-image-cropper';
import { DirectiveModule } from '../directives/directives.module';
import { BrandsTableComponent } from './brands-table/brands-table.component';
import { CategoryTreeV2Component } from './category-tree-v2/category-tree.v2.component';
import { CategoryTreeComponent } from './category-tree/category-tree.component';
import { CollectionTableComponent } from './collection-table/collection-table.component';
import { DualPaginationComponent } from './dual-pagination/dual-pagination.component';
import { ElasticSearchComponent } from './elasticSearch/elasticSearch.component';
import { GenericSelectComponent } from './generic-select/generic-select.component';
import { ImageCropperModalComponent } from './image-cropper/image-cropper.component';
import { ImageUploaderComponent } from './image-uploader/image-uploader.component';
import { InputComponent } from './input/input.component';
import { KeyboardComponent } from './keyboard/keyboard.component';
import { LoadingComponent } from './loading/loading.component';
import { MenuComponent } from './menu/menu.component';
import { MessageComponent } from './message/message.component';
import { ModalGenericoComponent } from './modal-generico/modal-generico.component';
import { ModalParameterAlertComponent } from './modal-parameter-alert/modal-parameter-alert.component';
import { ModalSelectComponent } from './modal-select/modal-select.component';
import { NotificationBadgeComponent } from './notification-badge/notification-badge';
import { NotificationsComponent } from './notifications/notifications.component';
import { PaginationComponent } from './pagination/pagination.component';
import { ProductPriceCardComponent } from './product-price-card/product-price-card.component';
import { ProductSearchComponent } from './product-search/product-search.component';
import { ProductsTableComponentV2 } from './products-table-v2/products-table.compoent';
import { ProductsTableComponent } from './products-table/products-table.compoent';
import { RelatedProductTableComponent } from './related-products-table/related-products-table.component';
import { SearchComponent } from './search/search.component';
import { SelectComponent } from './select/select.component';
import { SpecificationsTableComponent } from './specifications-table/specifications-table.component';
import { ToastMessageComponent } from './toast-message/toast-message.component';
import { TooltipComponent } from './tooltip/tooltip.component';
import { CategoryTreeSpecificationsComponent } from './category-tree-specifications/category-tree.specifications.component';
import { FiltersModalComponent } from './filters-modal/filters-modal.component';
import { MultiSelectComponent } from './multi-select/multi-select.component';
import { RedirectTableComponent } from './redirect-table/redirect-table.component';
import { RedirectRulesTableComponent } from './redirect-rules-table/redirect-rules-table.component';
import { SkusTableComponent } from './skus-table/skus-table.component';


@NgModule({
	declarations: [
		InputComponent,
		ModalGenericoComponent,
		LoadingComponent,
		MessageComponent,
		MenuComponent,
		SelectComponent,
		MultiSelectComponent,
		PaginationComponent,
		DualPaginationComponent,
		CategoryTreeComponent,
		CategoryTreeV2Component,
		CategoryTreeSpecificationsComponent,
		KeyboardComponent,
		ModalSelectComponent,
		NotificationsComponent,
		SearchComponent,
		ProductsTableComponent,
		BrandsTableComponent,
		RedirectTableComponent,
		RedirectRulesTableComponent,
		SpecificationsTableComponent,
		ProductsTableComponentV2,
		SkusTableComponent,
		ElasticSearchComponent,
		ModalParameterAlertComponent,
		TooltipComponent,
		ToastMessageComponent,
		CollectionTableComponent,
		FiltersModalComponent,
		GenericSelectComponent,
		ImageCropperModalComponent,
		ImageUploaderComponent,
		ProductSearchComponent,
		RelatedProductTableComponent,
		ProductPriceCardComponent,
		NotificationBadgeComponent
	],
	imports: [CommonModule, ReactiveFormsModule, FormsModule, RouterModule, DirectiveModule, ImageCropperModule],
	exports: [
		InputComponent,
		ModalGenericoComponent,
		ModalParameterAlertComponent,
		LoadingComponent,
		MessageComponent,
		MenuComponent,
		SelectComponent,
		MultiSelectComponent,
		PaginationComponent,
		DualPaginationComponent,
		CategoryTreeComponent,
		CategoryTreeV2Component,
		CategoryTreeSpecificationsComponent,
		KeyboardComponent,
		ModalSelectComponent,
		NotificationsComponent,
		SearchComponent,
		ProductsTableComponent,
		BrandsTableComponent,
		RedirectTableComponent,
		RedirectRulesTableComponent,
		SpecificationsTableComponent,
		ProductsTableComponentV2,
		SkusTableComponent,
		ElasticSearchComponent,
		TooltipComponent,
		ToastMessageComponent,
		CollectionTableComponent,
		FiltersModalComponent,
		GenericSelectComponent,
		ImageCropperModalComponent,
		ImageUploaderComponent,
		ProductSearchComponent,
		RelatedProductTableComponent,
		ProductPriceCardComponent,
		NotificationBadgeComponent
	],
})
export class ComponentsModule { }
